
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TimelineLite, Timeline, TimelineMax} from "gsap";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {Harlequin} from "../../Harlequin";

export class HarlequinBetLineWin implements GameRoundPresentation {
    public stagger?:number;
    private _tl:Timeline;
    private _currentTimeScale:number = 1;
    private _delay:number = 0.65;

    constructor(stagger?:number) {
        this.stagger = stagger;
    }

    public abort(isActive:boolean, data:ParsedServerData):TimelineLite {
        const tl:TimelineMax = new TimelineMax();

        tl.add([
            ()=> HarlequinBetLineWin.hideAllBetLines(),
            () => HarlequinGameModuleConfig.multiplierBetWinView.resetAllLines()
        ]);

        return tl;
    }

    public getAnimation(data:ParsedServerData):Timeline | null {
        this._currentTimeScale = 1;
        if(!(data instanceof ParsedGameData) || data.betWins == undefined || data.betWins.length <= 0) {
            return null;
        }
        this._tl = this.getWinAnimations(data);
        return this._tl;
    }

    private getWinAnimations(data:ParsedGameData):Timeline {
        const tl:TimelineMax = new TimelineMax();

        tl.add(() => {}, this._delay);
        for(let i:number = 0; i < data.betWins.length; i++) {

            tl.add([
                () => HarlequinBetLineWin.showBetLine((<IBetLineWinData>data.betWins[i]).betLineIndex),
                () => {
                    if (Harlequin.api.gameClientConfiguration.displayIndividualWinsInGame) {
                        HarlequinGameModuleConfig.betLinesView.individualWinView.displayIndividualBetLineAmount(<IBetLineWinData>data.betWins[i]);
                    }
                },
                //() => this.getLineAnimation(<IBetLineWinData>data.betWins[i]),
                this.getMultiplierAnimation(<IBetLineWinData>data.betWins[i], (i === data.betWins.length - 1)? 0 : i * 0.055, (i === data.betWins.length - 1))
            ]);
            tl.add([
                () => HarlequinBetLineWin.hideBetLine((<IBetLineWinData>data.betWins[i]).betLineIndex ),
                ()=>{HarlequinGameModuleConfig.betLinesView.individualWinView.individualLineAmountReset()},
                HarlequinGameModuleConfig.multiplierBetWinView.resetBetline((<IBetLineWinData>data.betWins[i]).betLineIndex)
            ]/*, (i === data.betWins.length - 1)? "+=0.35" : "+=0"*/);


        }
        return tl;
    }

    private getLineAnimation(betLineWinData:IBetLineWinData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        for(let reelId:number = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
            //tl.add(this.getSymbolAnimation(reelId, betLineWinData.betLine[reelId], GameConfig.instance.SYMBOL_STATES.win), 0);
        }

        return tl;
    }

    private getMultiplierAnimation(betLineWinData:IBetLineWinData, timeModifier:number = 0, last:boolean = false):Timeline {
        const tl:TimelineMax = new TimelineMax();
        const mpValue:number = Math.round(betLineWinData.multipliedAmount / betLineWinData.amount);

            //if(mpValue > 1) {
                tl.add([
                    () =>
                        !HarlequinGameConfig.instance.WIN_BELOW_STAKE && SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BETLINE_TICK),  // #323
                    HarlequinGameModuleConfig.multiplierBetWinView.playBetline(betLineWinData.betLineIndex, mpValue, betLineWinData.nrOfSymbols, timeModifier, last)
                    ]);
            //}

        return tl;
    }

    private getSymbolAnimation(reelId:number, symbolId:number, state:ISymbolStateConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            /*const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                setStack : true,
                fadeInDuration : 0.0
            })!;*/

            tl.add([
                () => HarlequinBetLineWin.sortSymbolDepthToTop(symbol)
                //,
                //symbolAnimation
            ]);
        }
        else {
            debugger;
            throw new Error(`Error: BetLineWin: Cannot find symbol at reel ${reelId} symbol ${symbolId}`);
        }
        return tl;
    }

    private static sortSymbolDepthToTop(symbol:StateReelSymbol):void {
        if(symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }

    private static showBetLine(betLineIndex:number):void {
        HarlequinGameModuleConfig.betLinesView.showBetline(betLineIndex);
    }

    private static hideBetLine(betLineIndex:number):void {
        HarlequinGameModuleConfig.betLinesView.hideBetline(betLineIndex);
    }

    private static hideAllBetLines():void {
        HarlequinGameModuleConfig.betLinesView.hideAllBetlines();
    }


}